import { Button } from "@/components/ui/button";
import { DEFAULT_ROUTES } from "@/constants/routes";
import { Pagination } from "@/features/pagination/layouts/pagination";
import { useBooking } from "@/features/private-room/bookings/hooks/use-booking";
import { BookingDetails } from "@/features/private-room/bookings/layouts/booking-details";
import { BookingListTable } from "@/features/private-room/bookings/layouts/booking-list-table";
import { FiltersBooking } from "@/features/private-room/bookings/layouts/filters-booking";
import { ModalDeleteBooking } from "@/features/private-room/bookings/layouts/modal-delete-booking";
import { ButtonExportBookings } from "@/features/private-room/bookings/layouts/shared/button-export-bookings/button-export-bookings";
import { PageBreadcrumb } from "@/layouts/page-container/shared/breadcrumb";
import { PlusIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";

export const BokaoList = () => {
  const [searchParams] = useSearchParams();

  const {
    bookings,
    handleChangePage,
    activePage,
    decreasePage,
    increasePage,
    handleSelectItem,
    selectedItem,
    handleCloseModal,
    setOpenDetail,
    openDetail,
    openDeleteModal,
    filters,
    updateFilters,
    PopulateBookings,
    qtdBookings,
    totalPages,
  } = useBooking();

  useEffect(() => {
    if (searchParams.get("po_contract_id")) {
      PopulateBookings(activePage, Number(searchParams.get("po_contract_id")));
    } else {
      PopulateBookings(activePage);
    }
  }, [filters]);

  return (
    <>
      <Toaster />
      <PageBreadcrumb>
        <div className="flex items-center ml-auto">
          <ButtonExportBookings
            filters={filters}
            className="border-slate-200 min-w-[220px] mb-7"
          />

          {import.meta.env.VITE_PO_CONTRACTS_RELEASED !== "true" && (
            <Link
              className="ml-auto"
              to={DEFAULT_ROUTES.PRIVATE_OFFICE_BOOKING_CREATE}
            >
              <Button className="bg-zinc-950 hover:bg-zinc-900 text-white ml-2 p-2 pr-3 rounded-md text-sm flex gap-1">
                <PlusIcon className="w-5" /> Criar bokão
              </Button>
            </Link>
          )}
        </div>
      </PageBreadcrumb>

      <FiltersBooking updateFilters={updateFilters} />

      <BookingListTable
        data={bookings}
        handleSelectItem={handleSelectItem}
        updateFilters={updateFilters}
        filters={filters}
      />

      <ModalDeleteBooking
        detail={selectedItem}
        open={openDeleteModal}
        handleCloseModal={handleCloseModal}
      />

      <BookingDetails
        detail={selectedItem}
        open={openDetail}
        handleCloseModal={() => setOpenDetail(false)}
      />

      <Pagination
        count={1000}
        page={activePage}
        onPageClick={handleChangePage}
        onPrevPageClick={decreasePage}
        onNextPageClick={increasePage}
        pageName="Bookings"
        totalLines={`${qtdBookings}`}
        totalPages={totalPages || 1}
      />
    </>
  );
};
